import {
    LASTREADING_REQUEST_DETAILS_OPEN_MODAL,
    LASTREADING_REQUEST_DETAILS_REQUEST,
    LASTREADING_REQUEST_DETAILS_RESULT
} from 'Redux/actionTypes';

export const lastReadingRequestDetailsOpenModal = (open, data, total) => ({
    type: LASTREADING_REQUEST_DETAILS_OPEN_MODAL,
    payload: { open, data, total }
})

export const lastReadingRequestDetailsRequest = (data, nextToken) => ({
    type: LASTREADING_REQUEST_DETAILS_REQUEST,
    payload: { data, nextToken }
})

export const lastReadingRequestDetailsResult = (data) => ({
    type: LASTREADING_REQUEST_DETAILS_RESULT,
    payload: { data }
})